<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="light bg-white print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation?.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full px-4 pl-6 pt-4 pb-4">
            <div class="flex items-center justify-center">
                <img class="w-[97px] h-[40px]" [src]="imageTenant" (error)="onImageError($event)">
                <!-- <miniapps></miniapps> -->
            </div>
            <div class="flex items-center ml-auto">
                <!-- <miniapps></miniapps> -->
                <button *ngIf="isOpened" mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon class="text-[#111827]">keyboard_double_arrow_left</mat-icon>
                </button>
            </div>
        </div>
        <!-- User -->
        <!-- <div class="flex flex-col items-center w-full p-4">
            <div class="flex flex-col items-center justify-center w-full">
                <div class="text-2xl font-extrabold tracking-tight text-logo self-center">
                    {{ "WELCOME" | transloco }}
                </div>
            </div>
        </div> -->
    </ng-container>
    <!-- Navigation footer hook -->
    <!-- <ng-container fuseVerticalNavigationContentFooter>
        <div class="flex flex-0 items-center justify-center h-12 pr-6 pl-2 mt-2 mb-4 opacity-12">
            <img
                class="max-w-36"
                src="assets/images/logo/logo-text-on-dark.svg">
        </div>
    </ng-container> -->
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="header relative flex flex-0 items-center w-full px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden [&_button]:max-h-full">
        <!-- Navigation toggle button -->
        <button *ngIf="!isOpened" mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <!-- <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon> -->
            <mat-icon class="text-[#111827]">keyboard_double_arrow_right</mat-icon>

        </button>
        <!-- <miniapps></miniapps> -->
        <div>
            <p class="heading-h4" [style.color]="colorTitlePage">
                <a [href]="urlHeader || 'javascript:void(0)'" [ngStyle]="{
                    'text-decoration': 'none',
                    'cursor': urlHeader ? 'pointer' : 'default'
                }">{{ titlePage | transloco }} <span *ngIf="countHeader">{{countHeader |
                        formatBreadcrumbNumber}}</span></a>
            </p>
            <p *ngIf="subMenu && subMenu.length > 0" class="breadcrumb">
                <ng-container *ngFor="let item of subMenu; let isFirst = first; let isLast = last; let i = index">
                    <a [href]="item?.url || 'javascript:void(0)'"
                        [class]="isFirst ? 'body-medium-medium' : 'body-large-bold'" [ngStyle]="{
                                'text-decoration': 'none',
                                'cursor': item?.url ? 'pointer' : 'default'
                            }">
                        <!-- <span [class]="isFirst ? 'body-medium-medium' : 'body-large-bold'" [ngStyle]="{
                            'color': item.color
                            }">
                            {{ item?.title | transloco }} {{item?.count}}
                        </span>
                        <span *ngIf="!isLast" class="breadcrumb-separator"> > </span> -->
                        <span style="vertical-align: middle">
                            <mat-icon class="icon-size-5" [ngStyle]="{ 'color': item.color }"
                                [svgIcon]="'heroicons_outline:ats-chevron-right'">
                            </mat-icon>
                        </span>
                        <span [class]="isFirst ? 'body-medium-medium' : 'body-large-bold'"
                            [ngStyle]="{ 'color': item.color }">
                            {{ item?.title | transloco }} {{item?.count | formatBreadcrumbNumber}}
                        </span>
                    </a>
                </ng-container>
            </p>
            <!-- <p *ngIf="detailPage"> <span class="subParent">{{titlePage | transloco}}</span> > <span class="subChild">{{detailPage | transloco}} <span *ngIf="countSub">{{countSub}}</span>  </span></p> -->
        </div>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <notifications></notifications>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">{{appName}} &copy; {{currentYear}}</span>
    </div>-->

</div>